const arrayIt = thing => Array.isArray(thing) ? thing : [ thing ]

export default arrayIt
